import React, { ComponentProps } from "react";

export default function UsersIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.2 12.0665V13.6665H6.10352e-05V12.0665C6.10352e-05 12.0665 6.10352e-05 8.86653 5.60005 8.86653C11.2 8.86653 11.2 12.0665 11.2 12.0665ZM8.40004 4.46654C8.40004 3.91276 8.23582 3.37141 7.92816 2.91095C7.62049 2.45049 7.18319 2.09161 6.67156 1.87969C6.15993 1.66776 5.59694 1.61231 5.0538 1.72035C4.51065 1.82839 4.01174 2.09506 3.62015 2.48665C3.22857 2.87823 2.96189 3.37714 2.85386 3.92029C2.74582 4.46344 2.80127 5.02642 3.01319 5.53805C3.22512 6.04968 3.584 6.48698 4.04445 6.79465C4.50491 7.10232 5.04626 7.26653 5.60005 7.26653C6.34265 7.26653 7.05484 6.97154 7.57994 6.44644C8.10504 5.92134 8.40004 5.20915 8.40004 4.46654ZM11.152 8.86653C11.6438 9.24713 12.0462 9.73088 12.331 10.2837C12.6157 10.8366 12.7758 11.4451 12.8 12.0665V13.6665H16V12.0665C16 12.0665 16 9.16253 11.152 8.86653ZM10.4 1.66655C9.84946 1.66399 9.31107 1.82857 8.85604 2.13855C9.34199 2.81754 9.60328 3.63157 9.60328 4.46654C9.60328 5.30151 9.34199 6.11555 8.85604 6.79454C9.31107 7.10451 9.84946 7.2691 10.4 7.26653C11.1426 7.26653 11.8548 6.97154 12.3799 6.44644C12.905 5.92134 13.2 5.20915 13.2 4.46654C13.2 3.72394 12.905 3.01175 12.3799 2.48665C11.8548 1.96155 11.1426 1.66655 10.4 1.66655Z"
        fill="currentColor"
      />
    </svg>
  );
}
